export default __webpack_public_path__ + "static/media/invictus_open_test_bannerweb.2f025cf3.webp";